import request from "./request";

export const http = {
  //费用类型查询
  getAccountNoList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/added/account/detail/getAccountNoList",
      params,
    });
  },
  //账单子类型查询
  getSerTypeList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/added/account/detail/getSerTypeList",
      data: params,
    });
  },
  //平台收入账单列表
  getList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/added/account/detail/getList",
      data: params,
    });
  },
    //平台收入账单列表（撮合服务费）
    getListSecond(params) {
      return request({
        method: "POST",
        url: "/platform/pc/platform/added/account/detail/getList2",
        data: params,
      });
    },
     //导出平台收入账单（撮合服务费）
  exportsecondExcel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/added/account/detail/exportExcel2",
      data: params,
      responseType: "blob",
    });
  },
  //导出平台收入账单
  exportExcel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/added/account/detail/exportExcel",
      data: params,
      responseType: "blob",
    });
  },
  //创建下拉框
  makeStoreSelect(params) {
    return request({
      method: "GET",
      url: "/platform/pc/warehouse/pull/down",
      params,
    });
  },
  //
};
